import { combineReducers } from "redux";
import users from "./users";
import accounts from "./accounts";
import jobs from "./jobs";
import costLimits from "./costLimits";
import accountSettings from "./accountSettings";

const entities = combineReducers({
  users,
  accounts,
  jobs,
  costLimits,
  accountSettings
});

export default entities;



// WEBPACK FOOTER //
// ./src/reducers/entities.js